"use client";

import { useEffect, useState } from "react";

import AddToCartButton from "@/src/features/cart/components/AddToCartButton";
import { cn } from "@/src/lib/utils/cn";

type ProductDetailsMobileAddBarProps = {
  productVariantId: number;
  selectedVariantIds: number[];
  isAvailable: boolean;
  hasSelectableInfoGroups: boolean;
  isFullProductSelected: boolean;
};

const mobileAddButtonClass =
  "min-h-[3.25rem] rounded bg-[#ee376a] px-4 py-3 text-sm font-extrabold text-white shadow-[0_16px_34px_rgba(238,55,106,0.28)] hover:bg-[#dd2f61] hover:text-white active:text-white";

export default function ProductDetailsMobileAddBar({
  productVariantId,
  selectedVariantIds,
  isAvailable,
  hasSelectableInfoGroups,
  isFullProductSelected,
}: ProductDetailsMobileAddBarProps) {
  const [isFooterVisible, setIsFooterVisible] = useState(false);

  useEffect(() => {
    const footer = document.querySelector("footer");

    if (!footer) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsFooterVisible(entry.isIntersecting);
      },
      {
        root: null,
        rootMargin: "0px 0px -72px 0px",
        threshold: 0.02,
      },
    );

    observer.observe(footer);

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div
      className={cn(
        "fixed inset-x-0 bottom-[calc(4rem+env(safe-area-inset-bottom))] z-[70] px-3 transition-all duration-300 ease-out lg:hidden",
        isFooterVisible
          ? "pointer-events-none translate-y-4 opacity-0"
          : "translate-y-0 opacity-100",
      )}
    >
      <div className="rounded-[1rem] border border-[rgba(238,55,106,0.16)] bg-white/92 p-2 shadow-[0_16px_42px_rgba(36,21,26,0.14)] backdrop-blur-xl">
        <AddToCartButton
          variantId={
            hasSelectableInfoGroups
              ? (selectedVariantIds[0] ?? null)
              : productVariantId
          }
          variantIds={hasSelectableInfoGroups ? selectedVariantIds : undefined}
          parentVariantId={
            hasSelectableInfoGroups ? productVariantId : undefined
          }
          isAvailable={
            isAvailable &&
            (!hasSelectableInfoGroups || selectedVariantIds.length > 0)
          }
          mode={hasSelectableInfoGroups ? "add" : "toggle"}
          label={
            hasSelectableInfoGroups
              ? isFullProductSelected
                ? "إضافة المنتج كامل للسلة"
                : `إضافة ${selectedVariantIds.length} اختيار للسلة`
              : "أضف إلى السلة"
          }
          redirectToCartOnSuccess
          className={cn(mobileAddButtonClass, "w-full border-0")}
        />
      </div>
    </div>
  );
}
